import { Link } from "gatsby";
import React from "react";

export default function Certify({
  backgroundCol,
  head,
  colHead,
  secondHead,
  para,
  leftHeadingFirst,
  leftHeadingmid,
  leftHeadingSecond,
  leftHeadingPara,
  src,
  bottomleftHeadingFirst,
  bottomleftHeadingmid,
  bottomleftHeadingSecond,
  bottomleftHeadingPara,
  RightHeadingFirst,
  RightHeadingmid,
  RightHeadingSecond,
  RightHeadingPara,
  ListFirst,
  ListSecond,
  ListThird,
  ListFourth,
}) {
  return (
    <div className={backgroundCol ? backgroundCol : "bg-darkBlue"}>
      <div className="mainDiv flex lg:flex-col flex-wrap mx-auto justify-center w-full lg:w-10/12 pt-24 max-w-6xl">
        <div className="divTop  flex flex-col justify-center items-center relative">
          <img src={`${src ? src : "https://tomedes.gumlet.io/frontend/images/services-new/certified_outline.webp"} `} alt="" className="absolute -top-5 inline-block w-full lg:w-10/12" />
          <h2 className="md:text-4xl text-2xl text-center text-white font-extrabold">
            {head ? head : " HOW DO WE"} <span className="text-orange">{colHead ? colHead : "CERTIFY"} </span>
          </h2>
          <h2 className="md:text-4xl text-2xl text-center text-white pt-2 font-extrabold"> {secondHead ? secondHead : "YOUR TRANSLATIONS"}</h2>
          <p className="text-center text-white text-[16px] font-light py-6 px-4 md:px-0 font-opensans">
            {para ? para : "With certified translations services, your translations go through a rigorous process of certification,to assure your document's acceptance in your desired institutions."}
          </p>
        </div>

        <div className="div flex flex-wrap mx-auto justify-center py-24 lg:px-0 px-4 gap-x-32">
          <div className="leftText text-white w-full lg:w-4/12 flex-col">
            <h3 className="text-2xl font-secondary font-bold pb-6">
              {leftHeadingFirst ? leftHeadingFirst : "What is "}
              <span className="text-orange">{leftHeadingmid ? leftHeadingmid : "certified"} </span>
              {leftHeadingSecond ? leftHeadingSecond : "translation?"}
            </h3>
            <p className="font-extralight font-opensans text-[16px] leading-loose">
              {leftHeadingPara
                ? leftHeadingPara
                : "According to the American Translator's Association, a certified translation is a document translation that must come with the affirmation of the accuracy and completeness of the translation. We use various factors to assure the accuracy and completeness of your translations, such as our certified translation company, our certified translators and industry professionals, and the help of recognized institutions like the ATA and the ISO. All your certified translations come with the official seal of Tomedes."}
            </p>
            <h3 className="text-2xl font-secondary  font-bold pt-20">
              {bottomleftHeadingFirst ? bottomleftHeadingFirst : ""} <span className="text-orange "> {bottomleftHeadingmid ? bottomleftHeadingmid : "Assurance"} </span>{" "}
              {bottomleftHeadingSecond ? bottomleftHeadingSecond : "of a 1-Year Guarantee"}
            </h3>
            <p className="font-light text-[16px] pb-10 mt-2">{bottomleftHeadingPara ? bottomleftHeadingPara : "Here is your assurance of a one-year guarantee"}</p>
            <Link to="/quality-guarantee" className="rounded-full py-2 px-6 bg-orange">
              LEARN MORE
            </Link>
          </div>

          <div className="rightComponent text-white leading-loose w-full lg:w-4/12 flex-col lg:pt-0 pt-6">
            <h3 className="text-2xl font-secondary font-bold pb-6">
              <span className="text-orange">Certifying </span>
              <span> {RightHeadingFirst ? RightHeadingFirst : "our translations"} </span>
              <span className="text-orange">{RightHeadingmid ? RightHeadingmid : ""}</span>
              <span className="text-orange">{RightHeadingSecond ? RightHeadingSecond : ""}</span>
            </h3>
            <ol className="divcontent list-decimal list-outside pb-14  ">
              <li className="text-orange">
                {" "}
                <span className="text-white text-[16px]  font-extralight leading-relaxed">{ListFirst ? ListFirst : "  Choosing the right translations for you or your business"}</span>
              </li>
              <li className="text-orange pt-4">
                {" "}
                <span className="text-white text-[16px] font-extralight leading-relaxed">{ListSecond ? ListSecond : "Translation of your document tailor-fitted to your needs"}</span>
              </li>
              <li className="text-orange pt-4">
                {" "}
                <span className="text-white text-[16px] font-extralight leading-relaxed">{ListThird ? ListThird : "Linguistic quality assurance that ensures quality and accuracys"}</span>
              </li>
              <li className="text-orange pt-4">
                {" "}
                <span className="text-white text-[16px] font-extralight leading-relaxed">{ListFourth ? ListFourth : " Provision of all certification documents preparing it for acceptance"}</span>
              </li>
            </ol>

            <div className="divcontent">
              <p className="font-extralight font-opensans text-[16px] py-10 leading-relaxed">
                {RightHeadingPara
                  ? RightHeadingPara
                  : "To ensure your satisfaction, all your certified translationscome with a one-year guarantee. This means you're insured forone year of all your translation projects with Tomedes. We areconfident with the quality of our work, but to make sure thatyou are satisfied with our service, we offer you up to one yearof translation revisions."}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
